import { Link } from "react-router-dom";
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { SubprocessorTable } from "../../components/SubprocessorTable";
import { SUBPROCESSORS_UPDATED } from "../../lib/subprocessors";

/**
 * Subprocessors — stable URL for customers and procurement to reference.
 * When this list changes, we update the "Last updated" date and give
 * 30 days notice per our Privacy Policy.
 */
export default function Subprocessors() {
  return (
    <div className="min-h-screen bg-white font-body text-slate-800">
      <Navbar />
      <main>

      <article className="mx-auto max-w-3xl px-6 py-12 leading-relaxed">
        <header className="mb-10 border-b border-slate-200 pb-6">
          <h1 className="text-4xl font-semibold text-slate-900">Subprocessors</h1>
          <p className="mt-2 text-sm text-slate-500">Last updated: {SUBPROCESSORS_UPDATED}</p>
          <p className="mt-4">
            The third parties below process personal data on Intakall's behalf. Each has
            access only to the data necessary to deliver their specific function, under a
            contract that aligns with our{" "}
            <Link to="/privacy" className="text-indigo-600 hover:underline">
              Privacy Policy
            </Link>
            {" "}commitments.
          </p>
          <p className="mt-3 rounded border border-slate-200 bg-slate-50 p-4 text-sm">
            <strong>Change notifications:</strong> when we add a new subprocessor with
            access to customer data, we update this page and email account administrators
            at least 30 days before the change takes effect. You may object during that
            window.
          </p>
        </header>

        <section>
          <div className="overflow-x-auto">
            <SubprocessorTable />
          </div>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-semibold text-slate-900">Cross-border transfers</h2>
          <p className="mt-3">
            Your data is primarily processed in the United Kingdom and the European
            Economic Area (server in London, database in Ireland, cache in the EU).
            Where data leaves the EEA or the UK — most notably for speech-to-text
            (Deepgram), topic extraction and summaries (OpenAI), and billing (Stripe) —
            we rely on Standard Contractual Clauses and equivalent safeguards from
            each subprocessor.
          </p>
        </section>

        <section className="mt-10">
          <h2 className="text-2xl font-semibold text-slate-900">Questions</h2>
          <p className="mt-3">
            Procurement and security teams: email{" "}
            <a href="mailto:security@intakall.io" className="text-indigo-600 hover:underline">
              security@intakall.io
            </a>
            {" "}for subprocessor audit letters, diligence questionnaires, or a DPA.
          </p>
        </section>

        <footer className="mt-16 border-t border-slate-200 pt-6 text-sm text-slate-500">
          <div className="flex flex-wrap gap-4">
            <Link to="/" className="text-indigo-600 hover:underline">← Back to Intakall</Link>
            <Link to="/privacy" className="text-indigo-600 hover:underline">Privacy Policy</Link>
            <Link to="/security" className="text-indigo-600 hover:underline">Security Trust Centre</Link>
          </div>
        </footer>
      </article>
      </main>
      <Footer />
    </div>
  );
}


